import React from "react"
import AnimateHeight from "react-animate-height"

import { Toggle } from "./shared/Inputs.jsx"

const SwitchCollapsableContent = ({ checked, onChange, children, label, duration = 300 }) => {
  const height = checked ? "auto" : 0

  return (
    <div className="mb-8 border border-gray">
      <div className="flex flex-row items-center border-b border-gray px-7 py-5">
        <Toggle checked={checked} onChange={onChange} />
        <label className="mb-0 ml-4 text-lg">{label}</label>
      </div>
      <AnimateHeight height={height} duration={duration}>
        {children}
      </AnimateHeight>
    </div>
  )
}

export default SwitchCollapsableContent
